"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Translate(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M14 3c.522 0 1.055.191 1.432.568.377.377.568.91.568 1.432v3h3c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2h-9c-1.1 0-2-.9-2-2v-3H5c-.522 0-1.055-.191-1.432-.568C3.191 15.055 3 14.522 3 14V5c0-.522.191-1.055.568-1.432C3.945 3.191 4.478 3 5 3zm1.4 8.1h-1.3l-2.5 6.701h1.5l.5-1.401H16l.4 1.401h1.5L15.4 11.1zM14 5H5v9h4l5-5V5zM4 17l2 2-2 2v-4zm10.801-4.199l.799 2.5h-1.7l.901-2.5zM10 6v1h2v1h-.031c-.146 1.269-.832 2.261-1.707 2.914l-.032.02c.241.04.495.066.77.066v1a5.078 5.078 0 0 1-2.006-.404C8.329 11.856 7.64 12 7 12v-1c.278 0 .58-.047.887-.113C7.336 10.37 7 9.72 7 9h1c0 .537.365 1.106 1.025 1.502.225-.111.44-.242.639-.391.672-.502 1.165-1.184 1.297-2.111H7V7h2V6h1zm10-3l-2 2 2 2V3z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Translate;
